<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock v-if="isAdmin">
        <v-row v-if="isAdmin">
          <v-col md="2">
            <v-text-field
              v-model.number="searchNoSiRh"
              label="Matricule"
              type="number"
              step="any"
              min="0"
              ref="input"
              :rules="[numberRule]"
              @keydown.enter="formDrhIndividu"
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <v-btn
              color="success"
              align-center
              @click="formDrhIndividu"
              :disabled="!isAdmin"
            >
              Recherche
            </v-btn>
          </v-col>
        </v-row>
      </BaseBlock>
      <BaseBlock
        title="Données personnelles et professionnelles"
        v-if="individu.noSiRh"
      >
        <v-row
          ><v-col cols="12" sm="12"
            >Si une donnée est erronée, contactez votre gestionnaire
            <strong>{{ individu.nomPrenomGestionnaire }}</strong
            >&nbsp;
            <a :href="'mailto:' + individu.mailGestionnaire"
              ><strong>{{ individu.mailGestionnaire }}</strong></a
            ></v-col
          ></v-row
        >
        <v-row v-if="isAdmin"
          ><v-col cols="6" sm="2" class="text-right text-caption"
            ><span class="red--text">*&nbsp;</span>Matricule :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.noSiRh }}</strong></v-col
          ></v-row
        >
        <v-row v-if="isAdmin"
          ><v-col cols="6" sm="2" class="text-right text-caption"
            ><span class="red--text">*&nbsp;</span>N° INSEE :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.noInsee }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >N° Ministériel (NUMEN):<br />
            <em>uniquement pour les titulaires</em></v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.numen }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >Nom d'usage :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.nomUsuel }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >Nom de famille :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.nomPatronymique }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >Prénom :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.prenom }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >Date de naissance :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.dnaissance }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >Situation familiale :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.lsituationFamille }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >Téléphone portable :</v-col
          ><v-col cols="6" sm="10"
            ><strong>{{ individu.telephonePortable }}&nbsp;&nbsp;&nbsp;</strong
            ><v-btn
              color="blue-grey"
              class="white--text"
              elevation="2"
              x-small
              v-if="!isRechercheDRH"
              eeicon
              @click="goToTel"
              >modifier/supprimer le téléphone portable<v-icon small
                >edit</v-icon
              ></v-btn
            >
            &nbsp;
            <v-dialog transition="dialog-bottom-transition" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-icon large color="blue darken-2" v-bind="attrs" v-on="on">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <template v-slot:default="dialog">
                <v-card>
                  <v-toolbar color="primary" dark
                    ><v-icon large color="white darken-2">
                      mdi-help-circle-outline </v-icon
                    >&nbsp; Information</v-toolbar
                  >
                  <v-card-text>
                    <div class="pa-12" style="text-align: center">
                      <strong
                        >Votre numéro de téléphone portable personnel est
                        collecté ici à titre facultatif. Il pourra être utilisé
                        pour vous informer par SMS de toute mesures prises en
                        faveur de la sécurité des personnels et des usagers dans
                        les locaux. Il ne pourra pas être utilisé pour une autre
                        finalité sans votre consentement.<br />
                        (Article L712-2, Code de l'éducation) <br /><br />
                        <a
                          target="_blank"
                          href="https://www.univ-lille.fr/donnees-personnelles/personnels/direction-des-relations-humaines"
                          >Données personnelles/Personnels/DRH</a
                        >
                      </strong>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn text @click="dialog.value = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
            <!--<div>
              Votre numéro de téléphone portable personnel pourra être utilisé
              en cas d'urgence (Article L712-2, Code de l'éducation)
            </div>--></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="6" sm="2" class="text-right text-caption"
            >&nbsp;Adresse :</v-col
          ><v-col cols="6" sm="10"
            ><strong v-html="adresseIndividu"></strong>&nbsp;
            <v-btn
              color="blue-grey"
              class="white--text"
              elevation="2"
              x-small
              v-if="!isRechercheDRH"
              eeicon
              @click="goToAddress"
              ><v-icon small>edit</v-icon></v-btn
            >
          </v-col></v-row
        >
        <v-row v-if="isAdmin">
          <v-col cols="12" sm="12" class="text-caption">
            <span class="red--text"
              >*&nbsp; Visible uniquement par les gestionnaires.</span
            >
          </v-col>
        </v-row>
      </BaseBlock>
      &nbsp;
      <v-progress-linear
        color="grey lighten-1"
        buffer-value="0"
        stream
        v-if="isLoadingListeEmploi"
      ></v-progress-linear>
      <BaseBlock
        title="Liste des situations en cours"
        v-if="listeEmploi.length != 0"
      >
        <v-row>
          <v-col cols="12" md="12">
            <v-data-table
              :headers="headersEmploi"
              :items="listeEmploi"
              class="elevation-1"
              loading="true"
              v-if="listeEmploi.length != 0"
              dense
            >
              <template v-slot:[`item.typeSituation`]="{ item }">
                {{
                  item.typeSituation == "F" ? "Fonctionnaire" : "Contractuel"
                }}
              </template>
              <template v-slot:[`item.typeEmploi`]="{ item }">
                {{
                  item.typeEmploi == "1"
                    ? "BIATSS"
                    : item.typeEmploi == "2"
                    ? "Enseignant"
                    : "N.C."
                }}
              </template>
              <template v-slot:[`item.lcType`]="{ item }">
                <v-tooltip bottom color="grey" max-width="200px">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs">{{ item.lcType }}</span>
                  </template>
                  <span
                    >{{ item.llType
                    }}<span v-if="isAdmin"><br />{{ item.cType }}</span></span
                  >
                </v-tooltip>
              </template>
              <template v-slot:[`item.lcSousType`]="{ item }">
                <v-tooltip bottom color="grey" max-width="200px">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs">{{ item.lcSousType }}</span>
                  </template>
                  <span
                    >{{ item.llSousType }}
                    <span v-if="isAdmin">
                      <br />{{ item.cSousType }}
                    </span></span
                  >
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
      &nbsp;
      <BaseBlock
        v-if="individu.liquidation"
        title="Informations Liquidation WPRH"
      >
        <v-row
          ><v-col cols="2" class="text-right text-caption"
            >dossier administratif :</v-col
          ><v-col cols="10"
            ><strong>{{
              individu.liquidation.idDossierAdminitrif
            }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="2" class="text-right text-caption"
            >code fin situation :</v-col
          ><v-col cols="10"
            ><strong>{{ individu.liquidation.codeFinSituation }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="2" class="text-right text-caption"
            >date de fin situation :</v-col
          ><v-col cols="10"
            ><strong>{{
              formatDate(individu.liquidation.dateFinSituation)
            }}</strong></v-col
          ></v-row
        >
      </BaseBlock>
      &nbsp;
      <BaseBlock v-if="individu.npc" title="Informations winpaie">
        <v-row
          ><v-col cols="2" class="text-right text-caption">NPC :</v-col
          ><v-col cols="10"
            ><strong>{{ individu.npc.npc }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="2" class="text-right text-caption"
            >fin situation :</v-col
          ><v-col cols="10"
            ><strong>{{ individu.npc.finSituation }}</strong></v-col
          ></v-row
        >
        <v-row
          ><v-col cols="2" class="text-right text-caption"
            >date de fin situation :</v-col
          ><v-col cols="10"
            ><strong>{{ individu.npc.findateSituation }}</strong></v-col
          ></v-row
        >
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiIndividuRepository from "@/repositories/ApiIndividuRepository";
import { mapState } from "vuex";

export default {
  name: "IndividuData",
  components: { BaseBlock },
  data() {
    return {
      individu: {
        dnaissance: "",
        gestionnaire: "",
        lsituationFamille: "",
        mail: "",
        mailGestionnaire: "",
        nomInsee: "",
        noSiRh: "",
        nomPatronymique: "",
        nomPrenomGestionnaire: "",
        nomUsuel: "",
        prenom: "",
        uidGestionnaire: "",
        telephoneDomicile: "",
        adresse: "",
        telephonePortable: "",
        numen: "",
      },
      searchNoSiRh: 0,
      numberRule: (val) => {
        if (val < 0) return "Please enter a positive number";
        return true;
      },
      headersEmploi: [
        { text: "Situation", value: "typeSituation", groupable: true },
        { text: "Emploi", value: "typeEmploi" },
        { text: "Date début", value: "dateDebut" },

        { text: "Type", value: "lcType" },

        // { text: "Sous-type", value: "lcSousType" },
        { text: "Affectation", value: "lcStructure" },
        { text: "Composante", value: "lcStructureN2" },
      ],
      listeEmploi: [],
      isLoadingListeEmploi: true,
      isRechercheDRH: false,
    };
  },
  computed: {
    ...mapState(["user", "isAdmin"]),
    adresseIndividu() {
      // `this` points to the component instance
      if (this.individu.adresse === null) return "";
      else return this.individu.adresse.replace(/\n/g, "<br/>");
    },
  },
  async created() {
    this.individu = await ApiIndividuRepository.getAgentIndividu();

    this.searchNoSiRh = this.individu.noSiRh == "" ? 0 : this.individu.noSiRh;
    this.listeEmploi = await ApiIndividuRepository.getAgentListeEmploi();
    this.isLoadingListeEmploi = false;
    //console.table(this.listeEmploi);
  },
  methods: {
    async formDrhIndividu() {
      this.isRechercheDRH = true;

      this.searchNoSiRh = String(this.searchNoSiRh).padStart(12, "0");
      this.individu = null;

      this.individu = await ApiIndividuRepository.getDrhIndividu(
        this.searchNoSiRh
      );

      this.listeEmploi.splice(0, this.listeEmploi.length);
      this.isLoadingListeEmploi = true;
      //console.table(this.listeEmploi);
      //console.log(this.isLoadingListeEmploi);
      this.listeEmploi = await ApiIndividuRepository.getDrhListeEmploi(
        this.searchNoSiRh
      );
      //console.table(this.listeEmploi);
      this.isLoadingListeEmploi = false;
      //console.log(this.isLoadingListeEmploi);
    },
    goToTel() {
      this.$router.push({
        name: "telephone",
        params: {
          telephonePortableActuel: this.individu.telephonePortable,
        },
      });
    },
    goToAddress() {
      this.$router.push({
        name: "Adresse",
      });
    },
    /**
     * formater la date  YYYY-MM-DD -> DD/MM/YYYY
     * @param date
     */
    formatDate(date) {
      if (date.length == 10) {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
      return "";
    },
  },
};
</script>
